import Service from "./Service";

const basePath = '/api/examen-clinico-mamas';


const show = (idHistoria) => {
    const url = `${basePath}/show/${idHistoria}`;
    return Service.get(url);
}

const store = (idHistoria, payload, blob) => {
    const formData = new FormData()

    formData.append('imagen', blob, `examen_mama_${idHistoria}.png`)
    formData.append('id_historia', idHistoria)
    formData.append('hallazgos', JSON.stringify(payload.hallazgos))
    formData.append('observaciones', payload.observaciones)

    const url = `${basePath}/store`;  

    return Service.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export default {
    show,
    store
}
    